import React from 'react';
import { Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import styles from './styles/user-state-pill.module.scss';

/**
 * Small uppercase status pill used inside the User Details and
 * Payroll Sync Status cards (Figma 5747:1756 / 5747:1791 etc.).
 * Tone tokens mirror the ones surfaced by the Reports
 * `UserDetailPanel` so the user detail page stays visually
 * consistent with the rest of the admin.
 *
 * @param {Object} props
 * @param {('success' | 'pending' | 'missing' | 'error' | 'info' | 'danger' | 'neutral')} props.tone
 * @param {string} props.label
 */
function UserStatePill({ tone = 'neutral', label }) {
    return (
        <Text
            as={TextAs.SPAN}
            size={TextSizes.EXTRA_SMALL}
            className={`${styles.pill} ${styles[`pill_${tone}`] || styles.pill_neutral}`}
        >
            {label}
        </Text>
    );
}

export default UserStatePill;
